import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { PACKAGES } from "@/lib/content";
import { resolvePackageId } from "@/lib/serviceNames";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", company: "", country: "", service_interest: "", message: "" };
const SUCCESS = "Thank you. Your enquiry is with our team. We look forward to hearing more about your business.";

const submissionError = (error) => error?.response?.status === 422
  ? "Please check your details and try again."
  : "We could not send your enquiry. Please try again or email us directly.";

export const useEnquiryForm = () => {
  const [params] = useSearchParams();
  const selected = PACKAGES.find((item) => item.id === resolvePackageId(params.get("service")))?.name;
  const [form, setForm] = useState(() => ({ ...EMPTY, service_interest: selected ?? "" }));
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (selected) setForm((current) => ({ ...current, service_interest: selected }));
  }, [selected]);

  const set = (field) => (eventOrValue) => {
    const value = typeof eventOrValue === "string" ? eventOrValue : eventOrValue.target.value;
    setForm((current) => ({ ...current, [field]: value }));
  };

  const submit = async (event) => {
    event.preventDefault();
    setResult(null);
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Thank you! Your enquiry has been received. We'll be in touch shortly.");
      setResult({ ok: true, text: SUCCESS });
      setForm({ ...EMPTY });
    } catch (error) {
      const text = submissionError(error);
      toast.error(text);
      setResult({ ok: false, text });
    } finally {
      setLoading(false);
    }
  };
  return { form, loading, result, set, submit };
};